//生成8位的大小写字母随机数
export function generateRandomString() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'
  let str = ''
  for (let i = 0; i < 16; i++) {
    str += chars[Math.floor(Math.random() * chars.length)]
  }
  return str
}

export function getBeforeDate(periodType: string, dayOffset?: number) {
  let now = new Date()
  let months, days

  switch (periodType) {
    case 'today':
      break
    case 'all':
      now = new Date(2022, 7, 1)
      break
    case '7_days':
      days = 7
      now.setDate(now.getDate() - days)
      break
    case '1_month':
      months = 1
      now.setMonth(now.getMonth() - months)
      // 确保日期不会超出实际的最大日期
      now.setDate(
        Math.min(
          now.getDate(),
          new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        )
      )
      break
    case '3_months':
      months = 3
      now.setMonth(now.getMonth() - months)
      now.setDate(
        Math.min(
          now.getDate(),
          new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        )
      )
      break
    case '6_months':
      months = 6
      now.setMonth(now.getMonth() - months)
      now.setDate(
        Math.min(
          now.getDate(),
          new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        )
      )
      break
    case '1_year':
      now.setFullYear(now.getFullYear() - 1)
      break
    default:
      days = dayOffset ? dayOffset : 7
      now.setDate(now.getDate() - days)
      break
  }
  return (
    now.getFullYear() +
    '-' +
    String(now.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(now.getDate()).padStart(2, '0')
  )
}
